var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "maintain-directory-archived-component" }, [
    _c(
      "div",
      { attrs: { id: "maintain-directory-archived-header" } },
      [
        _c("div", { staticClass: "clearfix header-panel" }, [
          _c("div", { staticClass: "header" }, [
            _c("span", { staticClass: "notice-header" }, [
              _vm._v(_vm._s(_vm.$t("directory.maintainArchivedTitle"))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "directory-archived-search-panel row" }, [
          _c(
            "div",
            { staticClass: "multi-select-block multi-select-block--building" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("directory.label.building")))]),
              _vm._v(" "),
              _c("HKLSelect", {
                attrs: {
                  value: _vm.searchParams.building,
                  options: _vm.buildingOptions,
                  showSearch: true,
                  placeholder: "",
                },
                on: { change: _vm.updateBuildingInQuery },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "multi-select-block multi-select-block--type" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("directory.label.view")))]),
              _vm._v(" "),
              _c("HKLSelect", {
                attrs: {
                  value: _vm.searchParams.type,
                  options: _vm.viewTypes,
                  showSearch: true,
                  placeholder: "",
                },
                on: { change: _vm.updateTypeInQuery },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.displayFloorSelect,
                  expression: "displayFloorSelect",
                },
              ],
              staticClass: "multi-select-block multi-select-block--floor",
            },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("directory.label.floor")))]),
              _vm._v(" "),
              _c("HKLSelect", {
                attrs: {
                  value: _vm.searchParams.floor,
                  options: _vm.floorList,
                  showSearch: true,
                  placeholder: "",
                },
                on: { change: _vm.updateFloorInQuery },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.displayLobbySelect
            ? _c(
                "div",
                { staticClass: "multi-select-block multi-select-block--floor" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("directory.label.floor"))),
                  ]),
                  _vm._v(" "),
                  _c("InputField", {
                    staticClass: "maintain-input-field",
                    attrs: {
                      dirtyCheck: false,
                      value: _vm.searchCompanyParams.floor,
                    },
                    on: {
                      updateValue: function (val) {
                        return _vm.updateLobbyFloorInQuery(val)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "multi-select-block multi-select-block--officeName",
            },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("directory.label.officeName"))),
              ]),
              _vm._v(" "),
              _c("InputField", {
                staticClass: "maintain-input-field",
                attrs: {
                  dirtyCheck: false,
                  value: _vm.searchCompanyParams.engName,
                },
                on: {
                  updateValue: function (val) {
                    return _vm.updateOfficeNameInQuery(val)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.displayFloorSelect,
                  expression: "displayFloorSelect",
                },
              ],
              staticClass: "multi-select-block multi-select-block--premises",
            },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("directory.label.premises")))]),
              _vm._v(" "),
              _c("InputField", {
                staticClass: "maintain-input-field",
                attrs: {
                  dirtyCheck: false,
                  value: _vm.searchCompanyParams.premises,
                },
                on: {
                  updateValue: function (val) {
                    return _vm.updatePremisesInQuery(val)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "multi-select-block multi-select-block--date" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("directory.label.effectiveDate"))),
              ]),
              _vm._v(" "),
              _c("DatePicker", {
                attrs: {
                  calendarButton: true,
                  calendarButtonIcon: "fa fa-calendar",
                  value: _vm.filterParams.effectiveDate
                    ? new Date(_vm.filterParams.effectiveDate)
                    : null,
                },
                on: {
                  selected: function (val) {
                    return (_vm.filterParams.effectiveDate = val)
                  },
                  cleared: function () {
                    return (_vm.filterParams.effectiveDate = null)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "multi-select-block multi-select-block--date" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("directory.label.removeDate"))),
              ]),
              _vm._v(" "),
              _c("DatePicker", {
                attrs: {
                  calendarButton: true,
                  calendarButtonIcon: "fa fa-calendar",
                  value: _vm.filterParams.removeDate
                    ? new Date(_vm.filterParams.removeDate)
                    : null,
                },
                on: {
                  selected: function (val) {
                    return (_vm.filterParams.removeDate = val)
                  },
                  cleared: function () {
                    return (_vm.filterParams.removeDate = null)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "multi-select-block multi-select-block--date" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("directory.label.publishedDate"))),
              ]),
              _vm._v(" "),
              _c("DatePicker", {
                attrs: {
                  calendarButton: true,
                  calendarButtonIcon: "fa fa-calendar",
                  value: _vm.filterParams.publishedAt
                    ? new Date(_vm.filterParams.publishedAt)
                    : null,
                },
                on: {
                  selected: function (val) {
                    return (_vm.filterParams.publishedAt = val)
                  },
                  cleared: function () {
                    return (_vm.filterParams.publishedAt = null)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "multi-select-block" },
            [
              _c("label", [_vm._v(" ")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue",
                  attrs: { disabled: !_vm.canShowDirectory },
                  on: { click: _vm.showDirectory },
                },
                [_vm._v(_vm._s(_vm.$t("action.showDirectory")))]
              ),
              _vm._v(" "),
              _c("Popover", {
                attrs: {
                  text: _vm.$t("directory.hint.onlyShowLevel1"),
                  position: "top-left",
                  width: 300,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("DirectoryArchivedTable", { ref: "directoryArchivedTable" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }